module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_blonde.795f0fed.png";